import React, { Component } from 'react';

import Train from '../../services/train.js';
import Notification from '../../services/Notification.js';

class RecoverPasswordForm extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      onClose: props.onClose,
      onFormChange: props.onFormChange
    }
  }

  validate() {
    this.setState({});
  }

  sendEmail(evt) {
    
    evt.preventDefault();
    evt.stopPropagation();

    let email = this.refs.email.value;

    Train.sendRecoveryEmail({email})
    .then(() => {
      Notification.show('Please verify your e-mail account', 'success');
    })
    .catch(() => {
      Notification.show('Are you sure that\'s your e-mail?', 'error');
    })

  }

  render() {

    return (

      <form  className="userForm" noValidate>
        <fieldset>
          <a className="closeButton" onClick={this.state.onClose}> 
            <i className="fontastic icon-close clickable"></i>
          </a>
          <h2 className="fs-title">Recover your password</h2>
          <input autoFocus type="email" ref="email" onChange={this.validate.bind(this)} minLength="4" maxLength="80" pattern="([\w\-\.]+@([\w\-]+\.)+[\w\-]{2,4})?" placeholder="Email" />
          <input type="submit" onClick={this.sendEmail.bind(this)} name="submit" className="submit action-button" value="Send e-mail" />
        </fieldset>

      </form>
      
    );
  }

}

export default RecoverPasswordForm;



// WEBPACK FOOTER //
// ./src/js/components/credentials/RecoverPasswordForm.jsx